/**
 * Representa um município brasileiro com suas subdivisões geográficas,
 * conforme retornado pela API de localidades do IBGE.
 * @hideconstructor
 */
export class Municipality {
  /** Identificador do município (código IBGE). */
  readonly cityId: string;
  /** Nome do município. */
  readonly cityName: string;
  /** Identificador da microregião geográfica. */
  readonly microregionId: string;
  /** Nome da microregião geográfica. */
  readonly microregionName: string;
  /** Identificador da mesoregião geográfica. */
  readonly mesoregionId: string;
  /** Nome da mesoregião geográfica. */
  readonly mesoregionName: string;
  /** Identificador da região geográfica imediata. */
  readonly immediateRegionId: string;
  /** Nome da região geográfica imediata. */
  readonly immediateRegionName: string;
  /** Identificador da região geográfica intermediária. */
  readonly intermediateRegionId: string;
  /** Nome da região geográfica intermediária. */
  readonly intermediateRegionName: string;
  /** Identificador numérico da Unidade Federativa (estado). */
  readonly stateId: string;
  /** Sigla da Unidade Federativa (estado). */
  readonly stateAbbreviation: string;
  /** Nome completo da Unidade Federativa (estado). */
  readonly stateName: string;
  /** Identificador da macrorregião geográfica do Brasil. */
  readonly regionId: string;
  /** Sigla da macrorregião geográfica do Brasil. */
  readonly regionAbbreviation: string;
  /** Nome da macrorregião geográfica do Brasil. */
  readonly regionName: string;

  constructor(
    cityId: string,
    cityName: string,
    microregionId: string,
    microregionName: string,
    mesoregionId: string,
    mesoregionName: string,
    immediateRegionId: string,
    immediateRegionName: string,
    intermediateRegionId: string,
    intermediateRegionName: string,
    stateId: string,
    stateAbbreviation: string,
    stateName: string,
    regionId: string,
    regionAbbreviation: string,
    regionName: string
  ) {
    this.cityId = cityId;
    this.cityName = cityName;
    this.microregionId = microregionId;
    this.microregionName = microregionName;
    this.mesoregionId = mesoregionId;
    this.mesoregionName = mesoregionName;
    this.immediateRegionId = immediateRegionId;
    this.immediateRegionName = immediateRegionName;
    this.intermediateRegionId = intermediateRegionId;
    this.intermediateRegionName = intermediateRegionName;
    this.stateId = stateId;
    this.stateAbbreviation = stateAbbreviation;
    this.stateName = stateName;
    this.regionId = regionId;
    this.regionAbbreviation = regionAbbreviation;
    this.regionName = regionName;
  }
}
